/**
 * Tests whether the argument is null or undefined
 * @param  {Object} value Object compared
 * @return {Object}        Return true/false
 */

export default function isNullOrUndefined(value: any): boolean {
	return value === null || value === undefined;
}
